import FormControlLabel from '@mui/material/FormControlLabel';
import MuiSwitch from '@mui/material/Switch';
import type { SwitchProps as MuiSwitchProps } from '@mui/material/Switch';
import type { SxProps } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

interface SwitchProps extends MuiSwitchProps {
  label?: string;
  labelPlacement?: 'start' | 'end' | 'top' | 'bottom' | undefined;
  labelStyles?: SxProps<Theme>;
}

function Switch({
  label,
  checked,
  onChange,
  labelPlacement = 'start',
  labelStyles,
  ...rest
}: SwitchProps) {
  if (label) {
    return (
      <FormControlLabel
        control={
          <MuiSwitch
            checked={checked}
            onChange={onChange}
            inputProps={{ 'aria-label': 'controlled' }}
            {...rest}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
        sx={labelStyles}
      />
    );
  }

  return (
    <MuiSwitch
      checked={checked}
      onChange={onChange}
      inputProps={{ 'aria-label': 'controlled' }}
      {...rest}
    />
  );
}

export default Switch;
